import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {Router} from '@angular/router';
import {ParamService} from './param.service';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
// import {v4 as uuidv4} from 'uuid';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    banner = this.paramService.banner;
    isUserAuthenticated = false;
    checkUserHasActiveSession = false;
    populateSessionData$ = new BehaviorSubject(null);
    _window: any = window;
    isB2B: boolean = false;

    constructor( private paramService: ParamService, private http: HttpClient) {
        this.isB2B = this._window?.['AB']?.['userInfo']?.['siteType'] && this._window?.['AB']?.['userInfo']?.['siteType'] === 'B';
    }

    deleteCookie = (name: string, domain: string) => document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;

    setCookie = (name: string, value: string) => document.cookie = `${name}=${value}; path=/`;

    isLocal() {
        return this._window.location.href.indexOf('local') > 0;
    }

    assignUrl(url: string) {
        window.location.assign(url);
    }

    async getUserInfo() {
        // clear any existing cookies
        if(this.isB2B) {
            this.deleteCookie('ACI_S_B_ECommRedirectURL', '');
        } else {
            this.deleteCookie('ACI_S_ECommRedirectURL', '');
        }

        let url;
        if (this.isLocal()) {
            url = 'https://www-qa1.' + this.banner + '.com/bin/safeway/unified/userinfo?banner=' + this.banner;
        } else {
            url = 'https://' + window.location.host + '/bin/safeway/unified/userinfo?banner=' + this.banner;
        }
        await this.http.get(`${url}&rand=${Math.random()}`, {withCredentials: true}).subscribe((response: any) => {
                if (response && response['SWY_SHOP_TOKEN']) {
                    if (response.userType !== 'R') {
                        this.checkTokenValid(response);
                    } else {
                        localStorage.setItem('referralUrl', document.referrer);
                        this.redirectToSSO(response);
                    }
                } else {
                    localStorage.setItem('referralUrl', document.referrer);
                    this.redirectToSSO(response);
                }
            },
            error => {
                this.redirectToSSO(null);
            });

        return this.isUserAuthenticated;
    }

    async getUserLogedInToken() {
        // clear any existing cookies
        let url;
        let isUserAuthenticated;
        if (this.isLocal()){
            url = 'https://www-qa1.' + this.banner + '.com/bin/safeway/unified/userinfo?banner=' + this.banner;
        } else {
            url = 'https://' + window.location.host + '/bin/safeway/unified/userinfo?banner=' + this.banner;
        }
        await this.http.get(`${url}&rand=${Math.random()}`, {withCredentials: true}).subscribe((response: any) => {
                if (response && response['SWY_SHOP_TOKEN']) {
                    isUserAuthenticated = this.checkUserTokenValidity(response);
                    if (isUserAuthenticated) {
                        this.populateSessionData$.next({...(response), isTokenValid: isUserAuthenticated});
                    } else {
                        this.populateSessionData$.next({...(response), isTokenValid: isUserAuthenticated});
                    }
                } else {
                    isUserAuthenticated = false;
                    this.populateSessionData$.next({...(response), isTokenValid: isUserAuthenticated});
                }
            },
            error => {
                isUserAuthenticated = false;
            });
        return isUserAuthenticated;
    }

    checkTokenValid(user: any) {
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
            this.checkUserHasActiveSession = true;
        } else {
            this.isUserAuthenticated = false;
        }
    }

    checkUserTokenValidity(user: any) {
        let isTokenValid = false;
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            isTokenValid = true;
        } else {
            isTokenValid = false;
        }
        return isTokenValid;
    }

    isTokenValidForSession(user: any) {
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
        } else {
            this.isUserAuthenticated = false;
        }
        return this.isUserAuthenticated;
    }

    isUserLoggedIn(user: any) {
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
            this.checkUserHasActiveSession = true;
        } else {
            this.isUserAuthenticated = false;
        }
        return this.isUserAuthenticated;
    }

    redirectToSSO(user: any) {
        const sso_url = this.getSSORoute(user);
        if(this.isB2B) {
            this.setCookie('ACI_S_B_ECommRedirectURL', encodeURIComponent(window.location.href));
        } else {
            this.setCookie('ACI_S_ECommRedirectURL', encodeURIComponent(window.location.href));
        }
        this.assignUrl(sso_url);
    }

    getApplicationDomainURL() {
        let domain;
        if (this.isLocal()) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + window.location.host;
        }
        return domain;
    }

    getSSORoute(user: any) {
        let sso_url;
        if (user && user['userType'] === 'G') {
            sso_url = this.getApplicationDomainURL() + environment.SIGN_IN_URL;
            sso_url = sso_url.replace(/\{banner\}/g, this.banner);
        } else if (user && user['userType'] === 'R') {
            sso_url = this.getApplicationDomainURL() + environment.RE_SIGN_IN_URL;
            sso_url = sso_url.replace(/\{banner\}/g, this.banner);
        } else {
            if (this._window['AB'] && this._window['AB']['COMMON'] && this._window['AB']['COMMON']?.getCookie('SAFEWAY_KMSI') === true) {
                sso_url = this.getApplicationDomainURL() + environment.RE_SIGN_IN_URL;
                sso_url = sso_url.replace(/\{banner\}/g, this.banner);
            } else {
                sso_url = this.getApplicationDomainURL() + environment.SIGN_IN_URL;
                sso_url = sso_url.replace(/\{banner\}/g, this.banner);
            }
        }
        return sso_url;
    }

    redirectToHome() {
        const url = this._window['SWY'].CONFIGSERVICE.bannerDomainMap['www-' + this.banner];
        if(this.isB2B) {
            this.setCookie('ACI_S_B_ECommRedirectURL', encodeURIComponent(window.location.href));
        } else {
            this.setCookie('ACI_S_ECommRedirectURL', encodeURIComponent(window.location.href));
        }
        this.assignUrl(url);
    }

    public isLSCompatible() {
      let test = 'test';
      try {
        if (typeof this._window['AB'].isLSEnabled == 'undefined') {
          localStorage.setItem(test, test);
          localStorage.removeItem(test);
          console.log('==== LOCAL STORAGE IS ENABLED ====');
          this._window['AB'].isLSEnabled = true;
        }
      } catch (e) {
        console.log('==== LOCAL STORAGE IS DISABLED ====');
        this._window['AB'].isLSEnabled = false;
      }
      return this._window['AB'].isLSEnabled;
    }
    public updateUserInfo(userInfo: any) {
        this._window["AB"].userInfo.SWY_SHOP_TOKEN = userInfo.SWY_SHOP_TOKEN;
        this._window["AB"].userInfo.email = userInfo.email;
        this._window["AB"].userInfo.banner = userInfo.banner || this.banner;
        this._window["AB"].userInfo.j4u.zipcode = userInfo.j4uZipcode || userInfo.zipcode;
        this._window["AB"].userInfo.clubCard = userInfo.clubCardNumber;
        this._window["AB"].userInfo.j4u.storeId = userInfo.j4uStoreId || userInfo.storeId;
        this._window["AB"].userInfo.firstName = userInfo.firstName;
        this._window["AB"].userInfo.displayableBanner = this._window["AB"].userInfo.displayableBanner || userInfo.displayableBanner;
        this._window["AB"].userInfo.pickupAddress = userInfo.pickupAddress;
        this._window["AB"].userInfo.customerId = userInfo.customerId;
        this._window["AB"].userInfo.userType = userInfo.userType;
        this._window["AB"].userInfo.siteType  = userInfo.siteType;
        this._window["AB"].userInfo.UUID = userInfo.UUID;
        this._window["AB"].userInfo.branchId = userInfo.j4uStoreId || userInfo.storeId;
        this._window["AB"].userInfo.expireTime = userInfo.expireTime;
        this._window["AB"].userInfo.houseId  = this.getUserHhid(userInfo.SWY_SHOP_TOKEN);
    }
    parseJwt(jwtToken: string) {
        const base64Url = jwtToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

    getUserHhid(token: string) {
        if(!token) {
            return "";
        }
        const oktaToken = this.parseJwt(token);
        return oktaToken['hid'];
    }

    public setEcommRedirectURLCookie() {
        let ecomCookieUrl;
        let currentPagePath = window.location.pathname + window.location.search;
        ecomCookieUrl = 'ACI_S_ECommRedirectURL'

        if (this.isB2B) {
        ecomCookieUrl = 'ACI_S_B_ECommRedirectURL';
        }
        this._window['AB']['COMMON']?.setCookie(ecomCookieUrl, encodeURI(currentPagePath));
    }
}
